import { ConditionalWrap } from '@libs/ui/ds'
import { useTrackScheduleFeaturesInteraction } from '@spa/core/externals/segment'
import { restModalDef } from '@spa/scenes/Plannings/Modals/RestModal/RestModal'
import {
  usePlanningPolicies,
  weeklyschedulesSelectors
} from '@spa/scenes/Plannings/redux/selectors'
import type { PropsWithChildren, FC, ReactElement } from 'react'
import React, { memo } from 'react'

import styles from './HandleRestClickContainer.module.css'

type Props = {
  restId: number
  weeklyscheduleId: number
  dataTestId?: string
}

const HandleRestClickContainer: FC<PropsWithChildren<Props>> = memo(
  ({ restId, weeklyscheduleId, children = null, dataTestId }) => {
    const { open } = restModalDef.useDispatchModal()
    const scheduleTracker = useTrackScheduleFeaturesInteraction()

    const weeklyschedule =
      weeklyschedulesSelectors.useGetCachedById(weeklyscheduleId)

    const { canEditRest, canEditPublishedRest } = usePlanningPolicies()

    const canEdit = weeklyschedule?.published
      ? canEditPublishedRest
      : canEditRest

    const handleClick = () => {
      scheduleTracker.scheduleElementCardOpened('rest')
      open({ restId, teamId: weeklyschedule.team_id })
    }

    return (
      <ConditionalWrap
        condition={canEdit}
        wrap={wrapChildren => (
          <button
            data-testid={dataTestId}
            className={styles.Container}
            onClick={handleClick}
          >
            {wrapChildren}
          </button>
        )}
      >
        {children as ReactElement}
      </ConditionalWrap>
    )
  }
)
HandleRestClickContainer.displayName = 'HandleRestClickContainer'

export default HandleRestClickContainer
